if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
        this.infoDelivery = this.querySelectorAll('.product-info-delivery__shipping-time');
        this.popupInfoDelivery();
      }

      popupInfoDelivery() {
        this.infoDelivery.forEach((infoDeliveryitem) => {
          const deliveryContentContainer = infoDeliveryitem.closest('.product-info-delivery__content');
          const deliveryClosePopup = deliveryContentContainer.querySelector('.close-popup');
          const deliveryPopupContent = deliveryContentContainer.querySelector('.product-info-delivery__popup');
          const originalParent = deliveryPopupContent.parentNode;

          infoDeliveryitem.addEventListener('click', () => {
            const isOpen = deliveryContentContainer.classList.toggle('open');

            if (isOpen && window.innerWidth <= 749) {
              document.body.classList.add('overflow-hidden');
              document.body.appendChild(deliveryPopupContent);
            } else {
              document.body.classList.remove('overflow-hidden');
            }

            this.infoDelivery.forEach((otherInfoDeliveryitem) => {
              const otherDeliveryContent = otherInfoDeliveryitem.closest('.product-info-delivery__content');
              if (otherDeliveryContent !== deliveryContentContainer) {
                otherDeliveryContent.classList.remove('open');
                otherDeliveryContent.querySelector('.product-info-delivery__popup').classList.add('hidden');
              }
            });

            deliveryPopupContent.classList.toggle('hidden', !isOpen);
          });

          deliveryClosePopup.addEventListener('click', closePopup);

          deliveryPopupContent.addEventListener('click', (event) => {
            if (event.target === deliveryPopupContent) {
              closePopup();
            }
          });

          function closePopup() {
            deliveryPopupContent.classList.add('hidden');
            deliveryContentContainer.classList.remove('open');
            document.body.classList.remove('overflow-hidden');
            originalParent.appendChild(deliveryPopupContent);
          }
        });
      }
      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (this.dataset.productId) {
          this.addProductToRecentProducts();
        }
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      addProductToRecentProducts() {
        const productId = this.dataset.productId;
        const recentProducts = JSON.parse(localStorage.getItem('recentProducts')) || [];
        if (!recentProducts.includes(productId) && recentProducts.length <= 40) {
          recentProducts.push(productId);
          localStorage.setItem('recentProducts', JSON.stringify(recentProducts));
        }
      }
    }
  );
}

const tabSelectVariant = document.querySelectorAll(
  '.section-main-product .product-form__variant-tab .product-form__variant-tab-select'
);
if (tabSelectVariant.length) {
  tabSelectVariant.forEach((tabSelectitem) => {
    tabSelectitem.addEventListener('click', () => {
      tabSelectVariant.forEach((tab) => tab.classList.remove('tab-active'));
      tabSelectitem.classList.add('tab-active');

      const dataTab = tabSelectitem.getAttribute('data-tab-select');
      const parentNodeTabSelect = tabSelectitem.closest('.product-form__variant');
      if (window.NewcopSizeSystem) {
        window.NewcopSizeSystem.set(dataTab);
      }

      parentNodeTabSelect.querySelectorAll('.label-variant-box').forEach((labelVariant) => {
        const showVariantClass = `variant-${dataTab}`;
        const hideVariantClass = `variant-${dataTab === 'eu' ? 'us' : 'eu'}`;

        labelVariant.querySelector(`.variant-label.${showVariantClass}`).classList.remove('hidden');
        labelVariant.querySelector(`.variant-label.${hideVariantClass}`).classList.add('hidden');
      });
    });
  });
}
document.addEventListener('DOMContentLoaded', function () {
  const inputVariants = document.querySelectorAll('.product-variant-size-container input');
  const deliveryInfo = document.querySelector('.product-info-delivery');
  const customQuickAddPDP = document.querySelector('.buy-buttons__form-custom');
  const btnFormSubmitAddPDP = document.querySelector('.product-form__buttons button');
  const containerVariantPDP = document.querySelector('.product-variant-size-container');
  const stickyBtnPdp = document.querySelector('.product-sticky-btn');
  const stickyBtnSubmitPdp = document.querySelector('.product-sticky-btn__button-submit');
  const contactBtnPdp = document.querySelector('.prodduct-contact-button__content');

  /* contactBtnPdp.addEventListener('click', function (event) {
    event.preventDefault();
    const iframeChat = document.getElementById('chat-button');
    const iframeDocument = iframeChat.contentDocument || iframeChat.contentWindow.document;
    const iframeButton = iframeDocument.getElementById('gorgias-chat-messenger-button');
    if (iframeButton) {
      iframeButton.click();
    }
  }); */

  // Note: Auto-select first variant with stock > 0 logic is handled in product-variant-picker.liquid

  if (customQuickAddPDP) {
    function checkScrollPdp() {
      const containerScrollY = window.scrollY;
      const positionFormCsTop = document.querySelector('.product-info-buy-btn').offsetTop;
      const positionFooter = document.querySelector('footer');
      const positionFooterTop = positionFooter ? positionFooter.getBoundingClientRect().top : 0;
      if (positionFooterTop > window.innerHeight) {
        stickyBtnPdp?.classList.remove('hidden');
      } else {
        stickyBtnPdp?.classList.add('hidden');
      }
      if (containerScrollY > positionFormCsTop) {
        customQuickAddPDP.classList.add('buy-buttons__form-sticky-active');
        stickyBtnPdp?.classList.remove('medium-hide', 'large-up-hide');
      } else {
        customQuickAddPDP.classList.remove('buy-buttons__form-sticky-active');
        stickyBtnPdp?.classList.add('medium-hide', 'large-up-hide');
      }
    }

    checkScrollPdp();

    window.addEventListener('scroll', checkScrollPdp);
  }

  const updateClasses = () => {
    const anyChecked = Array.from(inputVariants).some((input) => input.checked);
    if (!anyChecked) {
      customQuickAddPDP?.classList.remove('hidden');
    } else {
      customQuickAddPDP?.classList.add('hidden');
    }
  };

  const handleQuickAddClick = () => {
    const anyChecked = Array.from(inputVariants).some((input) => input.checked);
    const availableVariantsCount = Array.from(inputVariants).filter(
      (input) => !input.classList.contains('disabled')
    ).length;

    // Only show error if there are multiple available variants and none selected
    if (availableVariantsCount > 1 && !anyChecked) {
      containerVariantPDP?.classList.add('select-size');
    }
  };

  // Function to update third bullet (delivery) display - same logic as delivery info
  const thirdBulletDelivery = document.querySelector('[data-third-bullet-delivery]');

  const updateThirdBulletDisplay = (isVisible) => {
    if (!thirdBulletDelivery) return;

    if (isVisible) {
      thirdBulletDelivery.style.display = '';
    } else {
      thirdBulletDelivery.style.display = 'none';
    }
  };

  // Function to update delivery info display
  // Function to update stock info display
  const updateStockInfoDisplay = (inventory) => {
    const stockInfo = document.querySelector('[data-stock-info]');
    const stockText = document.querySelector('[data-stock-text]');

    if (!stockInfo || !stockText) return;

    // Get translations from window object or use fallbacks
    const translations = {
      stock_info_low: window.theme?.translations?.stock_info_low || 'Low stock available',
      stock_info_last_unit: window.theme?.translations?.stock_info_last_unit || 'Last unit',
    };

    if (inventory === 1) {
      stockText.textContent = translations.stock_info_last_unit;
      stockInfo.classList.remove('hidden');
    } else if (inventory > 1 && inventory <= 3) {
      stockText.textContent = translations.stock_info_low;
      stockInfo.classList.remove('hidden');
    } else {
      stockInfo.classList.add('hidden');
    }
  };

  const updateDeliveryInfoDisplay = (isFastShipping) => {
    if (!deliveryInfo) return;

    // Set classes
    deliveryInfo.classList.toggle('fast-shipping', isFastShipping);
    deliveryInfo.classList.toggle('normal-shipping', !isFastShipping);

    // Set display styles
    if (isFastShipping) {
      document.querySelector('.product-info-delivery__fast')?.style.setProperty('display', 'flex');
      document.querySelector('.product-info-delivery__fast')?.style.setProperty('align-items', 'center');
      document.querySelector('.product-info-delivery__fast')?.style.setProperty('flex-direction', 'row');
      document.querySelector('.product-info-delivery__fast')?.style.setProperty('justify-content', 'center');
      // document.querySelector('.fast-delivery-item')?.style.setProperty('display', 'flex');
      document.querySelector('.product-info-delivery__fast')?.style.setProperty('width', '100%');
      document.querySelector('.product-info-delivery__normal')?.style.setProperty('display', 'none');
    } else {
      document.querySelector('.product-info-delivery__normal')?.style.setProperty('display', 'flex');
      document.querySelector('.product-info-delivery__normal')?.style.setProperty('align-items', 'center');
      document.querySelector('.product-info-delivery__normal')?.style.setProperty('flex-direction', 'row');
      document.querySelector('.product-info-delivery__normal')?.style.setProperty('justify-content', 'center');
      document.querySelector('.product-info-delivery__normal')?.style.setProperty('width', '100%');
      document.querySelector('.product-info-delivery__fast')?.style.setProperty('display', 'none');
      // document.querySelector('.fast-delivery-item')?.style.setProperty('display', 'none');
    }
  };

  // Initialize third bullet delivery display - only show when fast shipping
  const initializeThirdBulletDisplay = () => {
    if (!thirdBulletDelivery) return;

    const checkedVariant = Array.from(inputVariants).find((input) => input.checked);
    const availableVariantsCount = Array.from(inputVariants).filter(
      (input) => !input.classList.contains('disabled')
    ).length;

    // If no variant inputs exist (single product without options), check if it's fast shipping
    if (inputVariants.length === 0) {
      // For products without variants, check if delivery info shows fast shipping
      const fastDeliveryVisible = document.querySelector('.product-info-delivery__fast');
      const isFastShipping = fastDeliveryVisible && fastDeliveryVisible.style.display !== 'none';
      updateThirdBulletDisplay(isFastShipping);
      return;
    }

    if (checkedVariant) {
      const isOutOfStock = checkedVariant.classList.contains('disabled');
      const isFastShipping = checkedVariant.hasAttribute('variant-fast-ship-input');
      // Only show third bullet when fast shipping AND in stock
      updateThirdBulletDisplay(isFastShipping && !isOutOfStock);
    } else if (availableVariantsCount === 1) {
      // Only 1 available variant, check if it's fast shipping
      const singleAvailableVariant = Array.from(inputVariants).find((input) => !input.classList.contains('disabled'));
      const isFastShipping = singleAvailableVariant?.hasAttribute('variant-fast-ship-input');
      updateThirdBulletDisplay(isFastShipping);
    } else {
      // Multiple variants and none selected, hide third bullet
      updateThirdBulletDisplay(false);
    }
  };

  const initializeDeliveryInfo = () => {
    if (!deliveryInfo) {
      // Still initialize third bullet even if no delivery info
      initializeThirdBulletDisplay();
      return;
    }

    const checkedVariant = Array.from(inputVariants).find((input) => input.checked);

    // Count available variants
    const availableVariantsCount = Array.from(inputVariants).filter(
      (input) => !input.classList.contains('disabled')
    ).length;

    if (checkedVariant) {
      // Variant is selected, check if it's in stock
      const isOutOfStock = checkedVariant.classList.contains('disabled');
      const hasFastShipAttr = checkedVariant.hasAttribute('variant-fast-ship-input');
      if (isOutOfStock) {
        deliveryInfo.style.display = 'none';
        // Hide third bullet when out of stock
        updateThirdBulletDisplay(false);
      } else {
        deliveryInfo.style.display = '';
        updateDeliveryInfoDisplay(hasFastShipAttr);
        // Show third bullet ONLY when fast shipping
        updateThirdBulletDisplay(hasFastShipAttr);
      }
    } else if (availableVariantsCount > 1) {
      // Multiple variants and none selected, hide delivery info
      deliveryInfo.style.display = 'none';
      // Hide third bullet when no variant selected
      updateThirdBulletDisplay(false);
    } else if (availableVariantsCount === 1) {
      // Only 1 available variant, show delivery info even if not selected yet
      deliveryInfo.style.display = '';
      // Check if single available variant is fast shipping
      const singleAvailableVariant = Array.from(inputVariants).find((input) => !input.classList.contains('disabled'));
      const isFastShipping = singleAvailableVariant?.hasAttribute('variant-fast-ship-input');
      updateThirdBulletDisplay(isFastShipping);
    }

    // Add class for single variant styling
    // Apply margin-top when there's only 1 variant OR no variants at all (inputVariants.length === 0)
    if (availableVariantsCount === 1 || inputVariants.length === 0) {
      deliveryInfo.classList.add('single-variant');
    } else {
      deliveryInfo.classList.remove('single-variant');
    }
  };

  // Add change event listeners to all variant inputs
  if (inputVariants.length) {
    inputVariants.forEach((inputVariant) => {
      inputVariant.addEventListener('change', () => {
        containerVariantPDP?.classList.remove('select-size');

        const isFastShipping = inputVariant.hasAttribute('variant-fast-ship-input');
        const isOutOfStock = inputVariant.classList.contains('disabled');
        const inventory = parseInt(inputVariant.getAttribute('data-inventory') || '0', 10);

        // Update stock info based on inventory
        if (!isOutOfStock) {
          updateStockInfoDisplay(inventory);
        } else {
          // Hide stock info if out of stock
          const stockInfo = document.querySelector('[data-stock-info]');
          stockInfo?.classList.add('hidden');
        }

        // Show third bullet ONLY when fast shipping (same as product-info-delivery__fast)
        updateThirdBulletDisplay(isFastShipping && !isOutOfStock);

        // Show/hide delivery info based on stock status
        if (deliveryInfo) {
          if (isOutOfStock) {
            deliveryInfo.style.display = 'none';
          } else {
            deliveryInfo.style.display = '';
            // Update delivery info display using the shared function
            updateDeliveryInfoDisplay(isFastShipping);
          }
        }

        updateClasses();
      });
    });
  }

  // Initialize stock info on page load
  const initializeStockInfo = () => {
    const checkedVariant = Array.from(inputVariants).find((input) => input.checked);
    if (checkedVariant) {
      const isOutOfStock = checkedVariant.classList.contains('disabled');
      if (!isOutOfStock) {
        const inventory = parseInt(checkedVariant.getAttribute('data-inventory') || '0', 10);
        updateStockInfoDisplay(inventory);
      }
    }
  };

  updateClasses();
  initializeDeliveryInfo();
  initializeStockInfo();

  // Re-initialize after auto-selection delay (variant-picker auto-selects after 500ms)
  setTimeout(() => {
    initializeDeliveryInfo();
    initializeStockInfo();
  }, 600);
  // Additional check after a longer delay to ensure it catches any late initializations
  setTimeout(() => {
    initializeDeliveryInfo();
    initializeStockInfo();
  }, 1000);

  customQuickAddPDP?.addEventListener('click', handleQuickAddClick);

  const description = document.querySelector('.product__description-detail');
  const btnShowDescription = document.querySelector('.btn-show-description');
  const readMore = document.querySelector('.des-read-more');
  const readLess = document.querySelector('.des-read-less');

  if (description) {
    function checkDescriptionHeight() {
      const lineHeight = parseFloat(getComputedStyle(description).lineHeight);
      const descriptionHeight = description.scrollHeight;
      let maxHeight = '';
      if (window.innerWidth >= 749) {
        maxHeight = lineHeight * 3;
      } else {
        maxHeight = lineHeight * 4;
      }
      if (descriptionHeight > maxHeight) {
        btnShowDescription.classList.remove('hidden');
      } else {
        btnShowDescription.classList.add('hidden');
      }
    }
    if (readMore) {
      readMore.addEventListener('click', function () {
        description.closest('.product__description').classList.remove('less-content');
        readMore.classList.add('hidden');
        readLess.classList.remove('hidden');
      });
      readLess.addEventListener('click', function () {
        description.closest('.product__description').classList.add('less-content');
        readMore.classList.remove('hidden');
        readLess.classList.add('hidden');
      });
    }
    checkDescriptionHeight();
  }

  if (inputVariants.length === 0) {
    if (stickyBtnSubmitPdp) {
      stickyBtnSubmitPdp.addEventListener('click', () => {
        stickyBtnSubmitPdp.classList.add('sticky-disabled');
        btnFormSubmitAddPDP?.click();
        setTimeout(() => {
          stickyBtnSubmitPdp.classList.remove('sticky-disabled');
        }, 500);
      });
    }
  }
  if (containerVariantPDP) {
    const getPositionVariantPDP = containerVariantPDP.getBoundingClientRect();
    const positionVariantPDP = getPositionVariantPDP.top + window.scrollY - 200;
    if (stickyBtnSubmitPdp) {
      stickyBtnSubmitPdp.addEventListener('click', () => {
        stickyBtnSubmitPdp.classList.add('sticky-disabled');
        const isVariantChecked = Array.from(inputVariants).some((inputVrt) => inputVrt.checked);
        const availableVariantsCount = Array.from(inputVariants).filter(
          (input) => !input.classList.contains('disabled')
        ).length;

        if (isVariantChecked) {
          window.scroll({
            top: positionVariantPDP,
            behavior: 'smooth',
          });
          btnFormSubmitAddPDP?.click();
        } else {
          window.scroll({
            top: positionVariantPDP,
            behavior: 'smooth',
          });
          // Only show error if there are multiple available variants
          if (availableVariantsCount > 1) {
            customQuickAddPDP?.click();
          } else {
            btnFormSubmitAddPDP?.click();
          }
        }
        setTimeout(() => {
          stickyBtnSubmitPdp.classList.remove('sticky-disabled');
        }, 500);
      });
    }
  }
});
